import aco from '../image/aco.png';
import caf from '../image/caf.png';
import cir from '../image/cir.png';
import com from '../image/com.png';
import coz from '../image/coz.png';
import lim from '../image/lim.png';
import lit from '../image/lit.png';
import sal from '../image/sal.png';
import sec from '../image/sec.png';
import vis from '../image/vis.png';


export const items = [
    {name: 'aco', icon: aco},
    {name: 'caf', icon: caf},
    {name: 'cir', icon: cir},
    {name: 'com', icon: com},
    {name: 'coz', icon: coz},
    {name: 'lim', icon: lim},
    {name: 'lit', icon: lit},
    {name: 'sal', icon: sal},
    {name: 'sec', icon: sec},
    {name: 'vis', icon: vis}
];